import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../store/store';
import get from 'lodash/get';
import { fetchLocation } from '../store/slices/locationSlice';

export const useLocation = () => {
  const dispatch = useDispatch();
  const { findAll } = useSelector((state: AppState) => state.location);

  useEffect(() => {
    dispatch(fetchLocation({ limit: 1000 }));
  }, []);

  return {
    items: get(findAll, 'payload.items', [])
  };
};
